/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './ActionTypes';

const dropDownPayload = {
  providerIdType: [],
};

const reducer = (state = dropDownPayload, action) => {
  switch (action.type) {
    case actionTypes.SET_ATTACHMENTS_DDD_VALUES: {
      return { ...state, ddValues: action.attachmentDDValues };
    }
    case 'LoggedInUser':
      return { ...state, logInUser: action.payload?.toString()?.toUpperCase() };
    case actionTypes.SET_CGP_CONTACT_DATA: {
      return { ...state, cgpRowData: action.cgpData };
    }
    case actionTypes.SET_GROUP_CONTACT_DATA: {
      return { ...state, groupRowData: action.groupData };
    }
    case actionTypes.SET_CLIENT_CONTACT_DATA: {
      return { ...state, clientRowData: action.clientData };
    }
    case actionTypes.GET_LOGIN_USER_DATA: {
      return { ...state, loginUserData: action.loginUserData };
    }
    case actionTypes.SHOW_SESSION_EXPIRY_DIALOG: {
      return { ...state, showSessionExpiryDialog: action.status };
    }
    case actionTypes.SESSION_EXPANDED: {
      return { ...state, sessionExtendStatus: action.status };
    }
    // case actionTypes.USER_IN_OUT_ACTION: {
    //   return { ...state, userInOutStatus: action.status };
    // }
    case actionTypes.KEYCLOAK_OBJ: {
      return { ...state, keycloakObj: action.obj };
    }
    case actionTypes.LOGIN_STATE_STORE: {
      return { ...state, loginStateStoreObj: action.logInStateStore };
    }
    case actionTypes.STORE_USER_AUTH_ROUTES: {
      return {
        ...state,
        storedUserAuthRoutes: action.storedUserAuthorizedRoutes,
      };
    }
    case actionTypes.REFRESH_TOKEN: {
      return {
        ...state,
        refreshTokenData: action.refreshTokenData,
        refreshTokenTime: new Date(),
      };
    }
    case actionTypes.SET_KC_ROLES: {
      return { ...state, kcRoles: action.payload };
    }

    default:
      return state;
  }
};

export default reducer;
